<template>
  <div>
    <list row-key="WarehouseId" ref="list" unit="仓库" :page="page" :query-params="params" :show-checkbox="showCheckbox"
      :show-query="showQuery" :get-data-func="getDataFunc">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="仓库名称">
          <el-input v-model="params.WarehouseName" placeholder="请输入仓库名称" clearable />
        </el-form-item>
        <el-form-item label="仓库类型" v-if="showType">
          <el-select v-model="params.WarehouseType" placeholder="请选择仓库类型" clearable>
            <el-option label="库存仓" :value="1"></el-option>
            <el-option label="车间仓" :value="2"></el-option>
            <el-option label="委外仓" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" v-if="!IsSelect">
          <el-select v-model="params.Status" placeholder="请选择状态" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="WarehouseNo" label="仓库编号" min-width="120px" />
        <el-table-column prop="WarehouseName" label="仓库名称" min-width="120px" />
        <el-table-column prop="ClassName" label="仓库类别" min-width="120px" />
        <el-table-column prop="WarehouseType" label="仓库类型" min-width="120px">
          <template slot-scope="{ row }">
            <span v-if="row.WarehouseType ===1">库存仓</span>
            <span v-if="row.WarehouseType ===2">车间仓</span>
            <span v-if="row.WarehouseType ===3">委外仓</span>
          </template>
        </el-table-column>
        <el-table-column prop="Remark" label="仓库备注" min-width="120px" show-overflow-tooltip />
        <el-table-column prop="Sn" label="序号" min-width="50px" align="left" />
        <el-table-column prop="WarehouseAddress" label="仓库地址" min-width="80px" />
        <el-table-column prop="IsCount" label="参与可用量" min-width="120px" align="center">
          <template slot-scope="{row}">
            <span v-if="row.IsCount == 1">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column prop="IsZeroCheckOut" label="允许零库存出库" min-width="120px" align="center">
          <template slot-scope="{row}">
            <span v-if="row.IsZeroCheckOut == 1">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column prop="Status" label="状态" align="center" width="70" v-if="!IsSelect">
          <template slot-scope="{ row }">
            <el-tag type="danger" v-if="row.Status == 0">停用</el-tag>
            <el-tag type="warning" v-if="row.Status == 1">启用</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    IsSelect: {
      type: Boolean,
      default: false,
    },
    showType: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      api: require("@/api/ba/warehouse").default,
      params: {
        WarehouseName: "",
        Status: null,
        WarehouseType: null,
      },
    };
  },
  methods: {
    getDataFunc(params = {}) { // <!-- h -->
      return new Promise((resolve) => {
        this.api.list({ ...params, IsFullStage: true}).then((res) => {
          resolve(res);
        });
      });
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.export(this.params).then(() => {
        loading.close();
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>